/**
 * Converts a color string (hex, rgb, rgba) to an rgba string with the specified alpha.
 *
 * @param {string} color - Color in hex (#RGB or #RRGGBB), rgb(), or rgba() format.
 * @param {number} [alpha=1] - Alpha value between 0 and 1.
 * @returns {string} Color in rgba() format, or empty string if input is invalid.
 */
export const changeAlphaOfColor = (color, alpha = 1) => {
  if (!color?.trim()) return "";

  if (color.includes("#")) {
    const hex = color.replace("#", "");
    const r = parseInt(
      hex.length === 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2),
      16
    );
    const g = parseInt(
      hex.length === 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4),
      16
    );
    const b = parseInt(
      hex.length === 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6),
      16
    );
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  if (color.includes("rgba(")) {
    return color.replace(/[^,]+(?=\))/, alpha.toString());
  }

  if (color.includes("rgb(")) {
    return color.replace(/rgb/i, "rgba").replace(/\)/i, `,${alpha.toString()}`);
  }

  return "";
};
